/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseBookingData } from './genericApiResponseBookingData';
import type { GenericApiResponseBookingMessage } from './genericApiResponseBookingMessage';
import type { GenericApiResponseBookingPagination } from './genericApiResponseBookingPagination';
import type { GenericApiResponseBookingError } from './genericApiResponseBookingError';

export interface GenericApiResponseBooking {
  data?: GenericApiResponseBookingData;
  message?: GenericApiResponseBookingMessage;
  pagination?: GenericApiResponseBookingPagination;
  error?: GenericApiResponseBookingError;
  statusCode?: number;
}
